document.addEventListener("DOMContentLoaded", () => {
    const collapsable = document.querySelectorAll('.sidebar-custom .nav-item.with-dropdown');

    // loop over toggleArea
    collapsable.forEach((collapsable) => {
        const toggleArea = collapsable.querySelector('.toggable-nav-item');

        toggleArea.addEventListener("click", function(event) {
            event.stopPropagation(); 
            const toggleIcon = collapsable.querySelector('.toggle-icon');
            const dropdown = collapsable.querySelector('.nav-section-items-dropdown');

            if (dropdown.classList.contains('show')) {
                dropdown.style.maxHeight = "0px";
                dropdown.classList.remove('show');
                toggleIcon.classList.remove('down');
            } else {
                dropdown.style.maxHeight = dropdown.scrollHeight + "px";
                dropdown.classList.add('show');
                toggleIcon.classList.add('down');
            }
        })
    });
}, { once: true });